import { isFictor } from './perfilFictor';

const normalizar = (valor: string) => valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
const produtos: Record<string, string> = {
  RCC_SAQUE: 'RCC - Cartão Benefício - SAQUE',
  RCC_COMPRA: 'RCC - Cartão Benefício - COMPRA',
  CARTAO_BENEFICIO: 'RCC - Cartão Benefício - SAQUE',
  'CARTAO BENEFICIO': 'RCC - Cartão Benefício - SAQUE',
  CARTAO_BENEFICIO_COMPRA: 'RCC - Cartão Benefício - COMPRA',
  CARTAO_CREDITO: 'RMC - Cartão Consignado',
  CARTAO_CREDITO_CONSIGNADO: 'RMC - Cartão Consignado',
  'CARTAO CREDITO': 'RMC - Cartão Consignado',
  'CARTAO CONSIGNADO': 'RMC - Cartão Consignado',
  EMPRESTIMO: 'Empréstimo',
};
const propostas: Record<string, string> = {
  CARTAO_SACADO: 'Novo', 'CARTAO SACADO': 'Novo',
  CARTAO_SEM_SAQUE: 'Novo', 'CARTAO SEM SAQUE': 'Novo', NOVO: 'Novo',
  'SAQUE NOVO / CONVENCIONAL': 'Novo',
  SAQUE_REFIN: 'Refin', 'SAQUE REFIN': 'Refin', REFINANCIAMENTO: 'Refin',
  COMPRA_DIVIDA: 'Compra de Dívida', 'COMPRA DE DIVIDA': 'Compra de Dívida',
  COMPRA_DIVIDA_SAQUE: 'Compra de Dívida', 'COMPRA DE DIVIDA SAQUE': 'Compra de Dívida',
  PORTABILIDADE: 'Portabilidade',
};

// Apenas apresentação: preserva IDs, nomes personalizados e valores enviados à API.
export const exibirNomeProduto = (valor?: string | null): string => {
  if (!valor) return '';
  if (!isFictor) return valor;
  const partes = valor.match(/^(\d+\s*-\s*)(.*)$/);
  const prefixo = partes?.[1] || '';
  const nome = partes?.[2] || valor;
  return prefixo + (produtos[normalizar(nome)] || nome);
};
export const exibirNomeProposta = (valor?: string | null): string =>
  valor ? (isFictor ? propostas[normalizar(valor)] || valor : valor) : '';
